import { render, staticRenderFns } from "./StoreOpenInquirePostList.vue?vue&type=template&id=77e6bc2f&scoped=true&"
import script from "./StoreOpenInquirePostList.vue?vue&type=script&lang=js&"
export * from "./StoreOpenInquirePostList.vue?vue&type=script&lang=js&"
import style0 from "./StoreOpenInquirePostList.vue?vue&type=style&index=0&id=77e6bc2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e6bc2f",
  null
  
)

export default component.exports